export enum VehicleType {
  ATV = 'ATV',
  Boat = 'BOAT',
  GolfCart = 'GOLF CARTS',
  Motorcycle = 'MOTORCYCLE',
  Outboard = 'OUTBOARD',
  OutboardRepower = 'OUTBOARD REPOWER',
  Scooters = 'SCOOTERS',
  SideBySides = 'SIDE-BY-SIDES',
  Snowmobile = 'SNOWMOBILE',
  Trailer = 'TRAILER',
  Watercraft = 'WATERCRAFT',
}
